document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname !== '/cart') return;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const seen = {};
      const updates = {};

      cart.items.forEach(item => {
        // Strip hidden properties (starting with _) before comparing
        const visibleProps = {};
        Object.keys(item.properties).forEach(k => {
          if (!k.startsWith('_')) visibleProps[k] = item.properties[k];
        });

        const key = `${item.variant_id}_${JSON.stringify(visibleProps)}`;

        if (seen[key]) {
          updates[seen[key].key] = seen[key].quantity + item.quantity;
          updates[item.key] = 0;
        } else {
          seen[key] = item;
        }
      });

      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(() => window.location.reload());
      }
    });
});
